// extracted by mini-css-extract-plugin
export default {"content":"SpecialistPersonPage_content__EuK4g","errorLink":"SpecialistPersonPage_errorLink__dGuHI","achievementContent":"SpecialistPersonPage_achievementContent__ToN4P"};